import { jsx } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { CourierProvider } from "@trycourier/react-provider";
import { getUserData } from "./index2.js";
import { API } from "./api.js";
import InboxList from "./InboxList.js";
function Inbox() {
  const [userId, setUserId] = useState(null);
  const [authToken, setAuthToken] = useState(null);
  const [isUserIdLoading, setIsUserIdLoading] = useState(true);
  const [isAuthTokenLoading, setIsAuthTokenLoading] = useState(true);
  useEffect(() => {
    async function fetchUserId() {
      try {
        setIsUserIdLoading(true);
        const userData = await getUserData();
        if (userData) {
          const id = userData.id;
          setUserId(id);
        }
      } catch (error) {
        console.error("Error fetching user ID:", error);
      } finally {
        setIsUserIdLoading(false);
      }
    }
    if (!userId) {
      fetchUserId();
    }
  }, [userId]);
  useEffect(() => {
    async function fetchAuthToken() {
      try {
        setIsAuthTokenLoading(true);
        const token = await API.getInboxToken();
        setAuthToken(token);
      } catch (error) {
        console.error("Failed to fetch token:", error);
      } finally {
        setIsAuthTokenLoading(false);
      }
    }
    fetchAuthToken();
  }, []);
  if (isUserIdLoading || isAuthTokenLoading) {
    return null;
  }
  if (!authToken || !userId) {
    console.error(
      "Authentication Token or user ID is not available to render the 3rd party Provider"
    );
    return null;
  }
  return /* @__PURE__ */ jsx(CourierProvider, { userId, authorization: authToken, children: /* @__PURE__ */ jsx(InboxList, {}) });
}
export {
  Inbox as default
};
//# sourceMappingURL=Inbox.js.map
